import { ref, computed } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f1561108"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "record-item"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = {
  key: 1
};
import { queryChangeRecord } from '@/api/payManage/appManage';
export default /*#__PURE__*/_defineComponent({
  __name: 'RecordModal',
  props: {
    currentRow: null
  },
  emits: ['update:modalVisible', 'update:editItem', 'refreshList'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const visible = ref(false);
    const loading = ref(false);
    const myType = ref('');
    const timeList = ref([
      // {
      //   id: '8277',
      //   logType: '产品管理/产品账号',
      //   tag: '更新',
      //   msg: '【设备ID】从【RF-test-lua】变成了【RF-test-lua1243】',
      //   diffDtoList: '[{"name":"设备ID","oldValue":"RF-test-lua","newValue":"RF-test-lua1243"}]',
      //   creator: '测试专用账号',
      //   createDate: '2025-08-07 18:26:00',
      // },
    ]);
    // 打开
    const openModal = async type => {
      try {
        loading.value = true;
        myType.value = type;
        visible.value = true;
        let params = {
          pageNum: 1,
          pageSize: 1000,
          logType: type == 'detail' ? '账号管理/分成比例' : '产品管理/产品账号',
          bizId: type == 'detail' ? props.currentRow.accountId : props.currentRow.dbtId // dbtid
        };
        const {
          code,
          data
        } = await queryChangeRecord(params);
        if (code == '0') {
          timeList.value = filterDataByType(data);
        }
      } catch {} finally {
        loading.value = false;
      }
    };
    // 关闭
    const closeModal = () => {
      visible.value = false;
    };
    // 根据myType过滤数据
    const filterDataByType = data => {
      return data.filter(item => {
        if (!item.diffDtoList) return false;
        if (myType.value === 'detail') {
          // 检查字符串中是否包含"分成比例"
          return item.diffDtoList.includes('分成比例');
        } else if (myType.value === 'account') {
          // 检查字符串中是否包含"账号/主体"
          return item.diffDtoList.includes('账号/主体');
        }
        return false;
      });
    };
    // 过滤编辑记录
    const filterText = computed(() => {
      return item => {
        if (!item.diffDtoList) return '';
        try {
          const arr = JSON.parse(item.diffDtoList);
          let targetDiff = null;
          // 获取与当前类型匹配的第一个项
          if (myType.value === 'detail') {
            targetDiff = arr.find(diff => diff.name === '分成比例');
          } else if (myType.value === 'account') {
            targetDiff = arr.find(diff => diff.name === '账号/主体');
          } else {
            targetDiff = arr[0];
          }
          if (targetDiff) {
            const str = `${targetDiff.name}：${targetDiff.oldValue} 变更为 ${targetDiff.newValue}；变更人：${item.creator}`;
            return str;
          }
          return '';
        } catch {
          return '';
        }
      };
    });
    // 暴露方法给父组件
    expose({
      openModal,
      closeModal
    });
    return (_ctx, _cache) => {
      const _component_a_timeline_item = _resolveComponent("a-timeline-item");
      const _component_a_timeline = _resolveComponent("a-timeline");
      const _component_a_empty = _resolveComponent("a-empty");
      const _component_a_spin = _resolveComponent("a-spin");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        class: "record-modal",
        title: "变更记录",
        onCancel: closeModal,
        onOk: closeModal,
        centered: "",
        open: visible.value,
        width: "620px",
        "ok-text": "确认",
        footer: null
      }, {
        default: _withCtx(() => [_createVNode(_component_a_spin, {
          spinning: loading.value
        }, {
          default: _withCtx(() => [timeList.value.length > 0 ? (_openBlock(), _createBlock(_component_a_timeline, {
            key: 0,
            class: "record-timeline"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timeList.value, (item, index) => {
              return _openBlock(), _createBlock(_component_a_timeline_item, {
                key: index
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, _toDisplayString(item.createDate), 1), _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(filterText)(item)), 1)])]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 1
          })) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_a_empty)]))]),
          _: 1
        }, 8, ["spinning"])]),
        _: 1
      }, 8, ["open"]);
    };
  }
});